var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 389,
    viewBox: "0 0 370 389",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.685 387.623L25.1998 324.32C6.70128 318.982 -3.96193 299.669 1.37657 281.184L66.2939 56.0707C71.6324 37.5721 90.9448 26.9089 109.429 32.2474L328.915 95.5507C347.414 100.889 358.077 120.202 352.738 138.686L287.821 363.8C282.482 382.299 263.17 392.962 244.685 387.623Z",
    fill: "#D5F1E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M368.3 10.6384L189.302 306.746C180.217 321.772 158.813 322.844 148.269 308.807L53.4423 182.591C48.8997 176.523 55.9623 168.576 62.5166 172.406L160.068 229.31L357.104 2.47598C362.686 -3.95116 372.705 3.34362 368.3 10.6439V10.6384Z",
    fill: "#39D862"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 229.5L224 156",
    stroke: "#1A2126",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.5 272.5L148.235 308.735C150.386 311.545 153.121 313.855 156.25 315.507V315.507C164.383 319.799 174.234 319.173 181.758 313.886L183.239 312.845C186.378 310.64 189.02 307.8 190.994 304.51L219.5 257",
    stroke: "#1A2126",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkLarge);
export default __webpack_public_path__ + "static/media/checkmark-large.8ea4eab60e49c04c7f1f8d5772234c02.svg";
export { ForwardRef as ReactComponent };